import { render, staticRenderFns } from "./BaseConfigurableProduct.vue?vue&type=template&id=201d77b1&scoped=true&"
import script from "./BaseConfigurableProduct.vue?vue&type=script&lang=js&"
export * from "./BaseConfigurableProduct.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfigurableProduct.vue?vue&type=style&index=0&id=201d77b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d77b1",
  null
  
)

export default component.exports